export default () => {
  return [
    {
      'id': 1,
      'title': 'Eget projekt'
    },
    {
      'id': 2,
      'title': 'Ahlsell'
    },
    {
      'id': 3,
      'title': 'Hat On Lady'
    },
    {
      'id': 4,
      'title': 'Stockholmsmässan'
    },
    {
      'id': 5,
      'title': 'Ecoscoter'
    },
    {
      'id': 6,
      'title': 'Friskis&Svettis'
    },
    {
      'id': 7,
      'title': 'Johnnie Walker'
    },
    {
      'id': 8,
      'title': 'Löfbergs Lila'
    },
    {
      'id': 9,
      'title': 'Metallica'
    },
    {
      'id': 10,
      'title': 'Pontus Olgrim'
    },
    {
      'id': 11,
      'title': 'Scandic'
    },
    {
      'id': 12,
      'title': 'Skandia'
    },
    {
      'id': 13,
      'title': 'Stadium Promotion'
    },
    {
      'id': 14,
      'title': 'Swedbank'
    },
    {
      'id': 15,
      'title': 'Svenska Spel'
    },
    {
      'id': 16,
      'title': 'Telia'
    },
    {
      'id': 17,
      'title': 'TeliaSonera'
    },
    {
      'id': 18,
      'title': 'Challengize'
    },
    {
      'id': 19,
      'title': 'Levels'
    },
    {
      'id': 20,
      'title': 'Red Line Oil'
    }
  ];
};